import * as React from 'react';
import { Translate } from '../../../../shared/LanguageService';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    close: () => void;
    images: { filename: string; reference: string }[];
}

const ArchiveSampleImagesModal = (props: IProps) => {
    const { apiUrl } = window.appConfig;

    return (
        <Modal show={true} onHide={props.close}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {Translate('view-order/basic-order-info/simaple-images-modal/title')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    {props.images &&
                        props.images.map((x, index) => (
                            <img
                                key={`sample-image-${index}`}
                                src={`${apiUrl}/file/${x.reference}`}
                                title={x.filename}
                            />
                        ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.close}>
                    {Translate('view-order/basic-order-info/simaple-images-modal/close-button')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ArchiveSampleImagesModal;
